import Pages from 'layouts/Pages.jsx';
import Redirection from 'views/Redirection';
import Dashboard from 'layouts/Dashboard.jsx';
import PickGenres from 'views/PickGenres';
import UserSocialAccounts from 'views/UserSocialAccounts';
import AllowSpotifyAccess from '../views/AllowSpotifyAccess';
import SpotifyAuthorization from '../views/SpotifyAuthorization';

var indexRoutes = [
  {
    path: '/allow-spotify-access',
    component: AllowSpotifyAccess,
  },
  {
    path: '/spotify-authorization/callback',
    component: SpotifyAuthorization,
  },
  {
    path: '/spotify-authorization/callback',
    component: SpotifyAuthorization,
  },
  {
    path: '/social-accounts',
    component: UserSocialAccounts,
  },
  {
    path: '/redirect',
    component: Redirection,
  },
  { path: '/pick-genres', name: 'Favorite Genres', component: PickGenres },
  { path: '/pages', name: 'Pages', component: Pages },
  { path: '/', name: 'Home', component: Dashboard },
];

export default indexRoutes;
